export const MapLayouts = Object.freeze({
    HORIZONTAL: "horizontal",
    VERTICAL: "vertical"
});